import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'sessionLogReport',
    label: 'Engagement & Participation Log',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
